<div
  class="fileupload"
  [ngStyle]="{width: imageSize, height: imageSize}"
>
  <input
    #file
    type="file"
    accept="image/png image/jpg image/jpeg"
    (change)="preview(file?.files)"
    data-cy="image-upload-input"
  />

  <ng-container *ngIf="imgURL; else profileImage">
    <div
      class="current-image mat-elevation-z8"
      [style.background-image]="getImage(imgURL)"
    ></div>
    <button
      mat-mini-fab
      class="edit-button special special-accent"
      (click)="file.click()"
    >
      <mat-icon>edit</mat-icon>
    </button>
  </ng-container>
</div>

<ng-template #profileImage>
  <div
    *ngIf="image$ | async as image; else defaultImage"
    [style.background-image]="image"
    class="current-image profile-image"
  >
    <button
      mat-mini-fab
      class="edit-button special special-accent"
      (click)="file.click()"
    >
      <mat-icon>edit</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #defaultImage>
  <div
    *ngIf="disabled; else disabledImage"
    class="default-image"
  >
    <ng-content *ngTemplateOutlet="uploadImageContent"></ng-content>
  </div>
  <ng-template #disabledImage>
    <div
      (click)="file.click()"
      class="default-image"
    >
      <ng-content *ngTemplateOutlet="uploadImageContent"></ng-content>
    </div>
  </ng-template>
</ng-template>

<ng-template #uploadImageContent>
  <mat-icon class="default-upload-icon">cloud_upload</mat-icon>
  <div class="upload-text">
    {{uploadText}}
  </div>
  <div class="upload-text-second-line">
    {{uploadTextSecondLine}}
  </div>
</ng-template>
